<template>
  <div class="mt-3">
    <chart />
    <statsTiles />
  </div>
</template>

<script>
import statsTiles from '../gmb/locations/insights/stat_tiles'
import chart from '../gmb/locations/insights/chart'

export default {
  components: { statsTiles, chart }
}
</script>
